import { Suspense, useMemo } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { AuthProvider } from "./auth/AuthContext";
import { ModalProvider } from "./context/ModalContext";

import LoadingSpinner from "./components/LoadingSpinner";
import RouteTracker from "./components/RouteTracker";
import LoginPage from "./pages/LoginPage/LoginPage";
import WorkInProgressPage from "./pages/WorkInProgressPage/WorkInProgressPage";

import { getFilteredRoutes } from "./routes/index.js";

const RootRedirect = () => {
	const { accessToken, isInitialized } = useAuth();
	if (!isInitialized) return null;
	return <Navigate to={accessToken ? "/dashboard" : "/login"} replace />;
};

function App() {
	const filteredRoutes = useMemo(() => getFilteredRoutes(), []);
	return (
		<AuthProvider>
			<BrowserRouter>
				<ModalProvider>
					<RouteTracker />
				<Suspense fallback={<LoadingSpinner />}>
						<Routes>
							<Route path="/" element={<RootRedirect />} />
							<Route path="/login" element={<LoginPage />} />
							{filteredRoutes.map((route, N) => (
								<Route
									key={`router-${N}`}
									path={route.path}
									element={route.element}
								/>
							))}
							<Route path="*" element={<WorkInProgressPage />} />
						</Routes>
					</Suspense>
				</ModalProvider>
			</BrowserRouter>
		</AuthProvider>
	);
}

export default App;
